export const sheetSubjectId = (sheet) => {
  const pid = sheet?.parcel_id?.[0] ?? sheet?.ParcelID?.[0];
  return pid == null || pid === '' ? '' : String(pid);
};

export const sheetForParcel = (sheets, parcelId) => {
  const target = String(parcelId ?? '');
  if (!target || !Array.isArray(sheets)) return { sheet: null, index: -1 };
  const index = sheets.findIndex((sheet) => sheetSubjectId(sheet) === target);
  return { sheet: index >= 0 ? sheets[index] : null, index };
};

/** Sheet subject id wins. An empty slot is used only when that case's parcel id matches and the slot is not another parcel. */
export const sheetIndexForParcel = (sheets, cases, parcelId) => {
  const found = sheetForParcel(sheets, parcelId);
  if (found.index >= 0) return found.index;
  const target = String(parcelId ?? '');
  const byCase = Array.isArray(cases) ? cases.findIndex((item) => String(item?.parcel_id) === target) : -1;
  if (byCase < 0 || !Array.isArray(sheets) || byCase >= sheets.length) return -1;
  const occupying = sheetSubjectId(sheets[byCase]);
  if (occupying && occupying !== target) return -1;
  return byCase;
};

export const replacedSheets = (sheets, cases, parcelId, nextSheet) => {
  const index = sheetIndexForParcel(sheets, cases, parcelId);
  if (index < 0 || !nextSheet) return { sheets, index: -1 };
  const next = sheets.slice();
  next[index] = nextSheet;
  return { sheets: next, index };
};

export const caseRefreshAssignmentLog = ({
  parcelId,
  responseRegularIndex,
  responseOptimizedIndex,
  regularIndex,
  optimizedIndex,
  regularSheets,
  optimizedSheets,
}) => {
  const target = String(parcelId ?? '');
  const regularSubject = sheetSubjectId(regularSheets?.[regularIndex]);
  const optimizedSubject = sheetSubjectId(optimizedSheets?.[optimizedIndex]);
  return {
    parcelId: target,
    responseRegularIndex,
    responseOptimizedIndex,
    regularIndex,
    optimizedIndex,
    regularSubject,
    optimizedSubject,
    regularMatched: regularIndex >= 0 && regularSubject === target,
    optimizedMatched: optimizedIndex >= 0 && optimizedSubject === target,
  };
};
